import styled from 'styled-components';
import { TColorNames } from '@_shared/styles';

export const Input = styled.div<{
	color?: TColorNames;
	placeholderColor?: TColorNames;
	borderColor?: TColorNames;
}>`
	width: 100%;
	height: 48px;

	padding: 12px;
	border-radius: 6px;
	border: 1px solid
		${({ theme, borderColor }) => (borderColor ? theme[borderColor] : theme['warmgray-200'])};

	display: flex;
	align-items: center;
	justify-content: center;

	input {
		width: 100%;
		height: 24px;

		font-family: 'Pretendard';
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
		color: ${({ color, theme }) =>
			color !== undefined ? theme[color] : theme['font-primary']};

		overflow: hidden;
		text-overflow: ellipsis;

		background-color: inherit;
		border: none;
		outline: none;
	}

	input::placeholder {
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
		color: ${({ placeholderColor, theme }) =>
			placeholderColor !== undefined ? theme[placeholderColor] : theme['font-tertiary']};
	}
`;
